@if (building(); as buildingValue) {
  <cfp-report-cover-page
    [enforcePdfRoute]="false"
    [portfolioId]="buildingValue.portfolio.id"
    [showDefaultTitle]="false"
    [showDefaultLogo]="false"
    [showFooter]="false"
    [showGradient]="showGradientCover()"
    [defaultCoverImage]="'img/report/building-report-cover.jpg'"
    [fallbackCoverImage]="'img/report/building-report-cover.jpg'"
    [coverPageClasses]="'building-report-cover-page'"
  >
    <ng-container cover-title>
      <cfp-building-details-header
        [building]="buildingValue"
        [hideSelect]="hideSelect()"
        [hideEnergyLabelRequirement]="true"
        [hideGoToAllBuildings]="hideGoToAllBuildings()"
        [hideDeleteBuilding]="hideDeleteBuilding()"
        [canDownloadReport]="canDownloadReport()"
      />
      <h1 [innerHtml]="reportCoverTitle() | translate"></h1>
      <span class="h4 fw-lighter report-date">{{ currentDate | date: 'longDate' }}</span>
    </ng-container>

    <ng-container cover-logo>
      <img [src]="`${environment.customerAssetsDir}img/${environment.images.logoNavbar}`" alt="Logo" />
      @if (showAppName()) {
        <span class="h2 ms-2 dark mb-0">{{ environment.appName }}</span>
      }
    </ng-container>

    <div cover-chrome-footer class="building-report-footer">
      <cfp-building-report-footer [showLogo]="showFooterLogo()" />
    </div>
  </cfp-report-cover-page>
}
